/** Client-side rules for the organisation details PIN. The API checks again. */

export const PIN_MIN = 4;
export const PIN_MAX = 8;

export function pinProblem(pin, confirmation) {
  const value = String(pin || '').trim();
  if (!/^\d+$/.test(value) || value.length < PIN_MIN || value.length > PIN_MAX) {
    return 'PIN must be 4 to 8 digits.';
  }
  if (confirmation !== undefined && value !== String(confirmation || '').trim()) {
    return 'PIN and confirmation do not match.';
  }
  return '';
}
